import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';

import { HighlightWords, theme } from '@sg/garnish';

export const CustomizationFooterText = (props: Props) => {
  const { style, ...restProps } = props;

  return (
    <View style={styles.container}>
      <HighlightWords sizeMatch={['24']} style={[styles.text, style]} {...restProps} />
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  text: {
    color: theme.colors.DARK_KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = ComponentProps<typeof HighlightWords>;
